export const burnetModis =  [
    { color: '#FF0000', label: 'Dernier jour' },
    { color: '#FFA500', label: '7 derniers jours' },
    { color: '#0000FF', label: '30 derniers jours' },
    { color: '#008000', label: 'Saison des feux' }
  ]